import { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useNavigate } from "react-router-dom";

export const OperatorTab = (index: any) => {
  // state for active tab index
  const [activeIndex, setActiveIndex] = useState<number>(index.index);

  // state for navigation
  const navigate = useNavigate();

  // handle tab change
  const tabChange = (e: any) => {
    setActiveIndex(e.index);

    if (e.index === 0) {
      navigate("/operator/operator-list");
    } else if (e.index === 1) {
      navigate("/operator/equipments");
    }
  };

  return (
    <>
      <TabView activeIndex={activeIndex} onTabChange={(e) => tabChange(e)}>
        <TabPanel header="Operators"></TabPanel>
        <TabPanel header="Equipments"></TabPanel>
      </TabView>
    </>
  );
};
